import axios from "axios";
import FormData from "form-data";
import { toast } from "react-toastify";
import Router from "next/router";
import { CONTACT_US_INFO, CONTACT_US_INFO_ERROR } from "../types";


export const contactUs = (e) => async (dispatch) => {
  try {
    var data = new FormData();
    data.append("email", e.values.email);
    data.append("parameter", e.values.parameter);
    data.append("comments", e.values.comments);

    // console.log(data, '+++++++++++')
    var config = {
      method: "post",
      url: `${process.env.NEXT_PUBLIC_API_URL}/contact`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    const res = await axios(config);

    if (res.data.success == true) {
      // console.log('val',e.target,e,e.values);
      // toast.success(`Success`);
      toast.success(`Your comment is submitted successfully`, {
        position: 'top-right',
        onClose: () => e.values.comments = '',
      });
      dispatch({
        type: CONTACT_US_INFO,
        payload: res.data,
      });
    }
  } catch (error) {
    dispatch({
      type: CONTACT_US_INFO_ERROR,
      payload: error.response.data.message,
    });

    toast.error(error.response.data.message, {
      onClose: () => location.reload(),
    });
  }
};
